import { Store } from "@tanstack/react-store";

import { DEFAULT_FILTERS } from "../features/filters/constants";
import type { StoreState } from "./types";

export const createStore = () =>
  new Store<StoreState>({
    mobileFiltersOpen: false,
    mobileMapVisible: false,
    filters: DEFAULT_FILTERS,
  });

export type TStore = ReturnType<typeof createStore>;
